import moment from 'moment';
import 'moment/locale/ko';

export const setMomentLocale = (locale?: string) => {
  return locale && moment.locale(locale);
};
